module.exports = __webpack_public_path__ + "img/pentester.927b6639.png";